import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInsetIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M3 3h18v18H3z" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 8h8v8H8z" }),
		/* @__PURE__ */ _jsx("path", {
			d: "m3 3 5 5m13-5-5 5M3 21l5-5m13 5-5-5",
			opacity: .3
		})
	]
});
export default SvgInsetIcon;
